import styled, {css} from 'styled-components'

export const StyledEditProjectTeamFormFieldsGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 250px 1fr auto;
        gap: ${spacing * 4}px;
        width: 100%;
    `
)
